document.addEventListener("DOMContentLoaded", () => {
  const reviewTabEl = document.querySelector('.product-tab-item.product-reviews');
  
  if (!reviewTabEl) return;

  const observer = new MutationObserver((mutations, obs) => {
    const lipscoreSummaryEl = reviewTabEl.querySelector('.lipscore-review-summary');
    const reviewsCountEl = reviewTabEl.querySelector('.reviews-count');

    if (lipscoreSummaryEl && reviewsCountEl) {
      const reviewCount = lipscoreSummaryEl.getAttribute("data-ls-product-review-count") || 0;
      if(reviewCount != 0) {
        reviewTabEl.classList.remove('hidden');
        reviewsCountEl.textContent = `(${reviewCount})`;
      };
      obs.disconnect();
    }
  });

  observer.observe(reviewTabEl, {
    childList: true,
    subtree: true
  });
});